import { useCallback, useEffect, useState } from "react";
import { EVENTO_ERROR, mensajeDeError } from "../errores";
import { EVENTO_AVISO } from "../avisos";

const DURACION_MS = { error: 7000, exito: 4000, info: 6000 };
const MAXIMO_VISIBLES = 3;

const ESTILO = {
  error: { borde: "border-rose-500/40", punto: "bg-rose-400", texto: "text-rose-100" },
  exito: { borde: "border-emerald-500/40", punto: "bg-emerald-400", texto: "text-white" },
  info: { borde: "border-white/20", punto: "bg-sky-400", texto: "text-white" },
};

// Toda petición que falla y que la pantalla no manejó (o que avisó con avisarError)
// se muestra aquí, en vez de fallar en silencio o dejar la pantalla a medias. También
// los avisos de las pantallas (avisar() de shared/avisos.js): "Guardado", un dato que falta...
function esErrorDePeticion(motivo) {
  return motivo?.name === "ErrorDeDatos" || (motivo instanceof TypeError && /fetch|network/i.test(motivo.message));
}

function AvisosDeError() {
  const [avisos, setAvisos] = useState([]);

  const cerrar = useCallback((id) => setAvisos((actuales) => actuales.filter((a) => a.id !== id)), []);

  const agregar = useCallback((texto, tipo = "error") => {
    const id = `${Date.now()}-${Math.random()}`;
    setAvisos((actuales) => {
      // El mismo aviso repetido (p. ej. varias cargas a la vez sin conexión) se muestra una vez.
      if (actuales.some((a) => a.texto === texto)) return actuales;
      return [...actuales, { id, texto, tipo }].slice(-MAXIMO_VISIBLES);
    });
    setTimeout(() => cerrar(id), DURACION_MS[tipo] || DURACION_MS.error);
  }, [cerrar]);

  useEffect(() => {
    const alFallar = (evento) => agregar(evento.detail, "error");
    const alAvisar = (evento) => agregar(evento.detail.texto, evento.detail.tipo);
    const sinManejar = (evento) => {
      const motivo = evento.reason;
      if (!esErrorDePeticion(motivo)) return;
      evento.preventDefault();
      agregar(mensajeDeError(motivo), "error");
    };
    window.addEventListener(EVENTO_ERROR, alFallar);
    window.addEventListener(EVENTO_AVISO, alAvisar);
    window.addEventListener("unhandledrejection", sinManejar);
    return () => {
      window.removeEventListener(EVENTO_ERROR, alFallar);
      window.removeEventListener(EVENTO_AVISO, alAvisar);
      window.removeEventListener("unhandledrejection", sinManejar);
    };
  }, [agregar]);

  if (avisos.length === 0) return null;
  return (
    <div className="fixed bottom-5 right-5 z-[80] flex w-[calc(100%-2.5rem)] max-w-sm flex-col gap-2">
      {avisos.map((aviso) => {
        const estilo = ESTILO[aviso.tipo] || ESTILO.error;
        return (
          <div
            key={aviso.id}
            role={aviso.tipo === "error" ? "alert" : "status"}
            className={`animate-deslizar flex items-start gap-3 rounded-2xl border bg-zinc-950/95 px-4 py-3 text-sm shadow-2xl backdrop-blur ${estilo.borde} ${estilo.texto}`}
          >
            <span className={`mt-1.5 h-2 w-2 shrink-0 rounded-full ${estilo.punto}`} aria-hidden="true" />
            <span className="flex-1">{aviso.texto}</span>
            <button onClick={() => cerrar(aviso.id)} aria-label="Cerrar aviso" className="text-gray-500 transition hover:text-white">✕</button>
          </div>
        );
      })}
    </div>
  );
}

export default AvisosDeError;
